import { XCircleIcon } from '@heroicons/react/20/solid';
import PropTypes from 'prop-types';
import BaseLoader from './BaseLoader';

function LoadingOrError({
  title = '',
  loading,
  error = null,
  hideText = false,
  className = '',
  data = null,
  dataKey = null,
  shouldShowLoading = null,
  shouldShowError = null,
}) {
  const showLoading = shouldShowLoading ?? loading;
  const showError =
    shouldShowError ??
    (!showLoading &&
      (error ||
        (dataKey ? data == null || data[dataKey] == null : data == null)));

  if (showLoading) {
    return (
      <BaseLoader title={title} hideText={hideText} className={className} />
    );
  }

  if (showError) {
    return (
      <div className="rounded-md bg-red-50 p-4">
        <div className="flex">
          <div className="shrink-0">
            <XCircleIcon className="size-5 text-red-400" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <h3 className="font-medium text-red-800 text-sm">
              An error occurred
            </h3>
            <div className="mt-2 text-red-700 text-sm">
              <ul className="list-disc space-y-1 pl-5">
                {error?.graphQLErrors?.map((err) => (
                  <li
                    key={
                      err.path?.join('.') || err.extensions?.code || err.message
                    }
                  >
                    {err.message}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return true;
}

LoadingOrError.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  hideText: PropTypes.bool,
  className: PropTypes.string,
  data: PropTypes.object,
  dataKey: PropTypes.string,
  shouldShowLoading: PropTypes.bool,
  shouldShowError: PropTypes.bool,
};

export default LoadingOrError;
